<template>
  <layout>
    <page-header :actions="actions" :header="$t('vehicles.title')" />
    <div class="content">
      <admin-table v-if="currentDivision" ref="table" v-bind="tableProps">
        <template slot="image" slot-scope="{ item }">
          <img
            v-if="item.image && item.image"
            :src="thumb(item.image, 120)"
            class="max-w-full"
            alt=""
          />
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehiclesApi from './Api'

const resourceBase = 'vehicles'

export default {
  name: 'Vehicles',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new VehiclesApi().setParameter(
            'division_id',
            this.currentDivision.id,
          )
        },
        sortBy: 'order',
        sortDesc: false,
        perPage: 9,
        columns: [
          {
            key: 'is_available',
            label: this.$t('vehicles.available'),
            sortable: true,
            component: 'value-boolean',
          },
          {
            key: 'image',
            label: this.$t('vehicles.image'),
          },
          {
            key: 'name',
            label: this.$t('vehicles.name'),
            sortable: true,
          },
          // {
          //   key: 'order',
          //   label: this.$t('general.order'),
          //   sortable: true,
          // },
          {
            key: 'features.wheelchair',
            label: this.$t('vehicles.wheelchair'),
            component: 'value-boolean',
          },
          {
            key: 'features.trailer',
            label: this.$t('vehicles.trailer'),
            class: 'min-w-60',
            component: 'value-boolean',
          },
          {
            key: 'features.booster_seat',
            label: this.$t('vehicles.booster_s'),
            component: 'value-boolean',
          },
          {
            key: 'features.baby_seat',
            label: this.$t('vehicles.baby_s'),
            class: 'min-w-60',
            component: 'value-boolean',
          },
          {
            key: 'features.child_seat',
            label: this.$t('vehicles.child_s'),
            class: 'min-w-60',
            component: 'value-boolean',
          },
          {
            key: 'features.bike',
            label: this.$t('vehicles.bike'),
            class: 'min-w-60',
            component: 'value-boolean',
          },
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: item => {
          let actions = []

          if (
            this.$allows(`${resourceBase}.update`) ||
            this.$allows(`${resourceBase}.view`)
          ) {
            actions.push('edit')
          }
          if (this.$allows(`${resourceBase}.delete`)) {
            actions.push({
              label: this.$t('general.delete'),
              variant: 'warning', // BS button variants
              handler: async () => {
                // prettier-ignore
                const { value: ok } = await this.$alert.question(this.$t('vehicles.messages.delete_question'), '', {
                    showCancelButton: true,
                  },
                )

                if (ok) {
                  try {
                    await new VehiclesApi().destroy(item.id)
                    this.$refs.table.refresh()
                  } catch (err) {
                    if (err.status === 400) {
                      this.$alert.error(
                        this.$t('vehicles.messages.delete_error'),
                      )
                    } else {
                      this.$toast.error(err.message)
                    }
                  }
                }
              },
            })
          }

          return actions
        },

        // define custom bulk actions
        bulkActions: () => {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      if (this.$allows(`${resourceBase}.create`)) {
        return [
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `${resourceBase}.create`,
              })
            },
          },
        ]
      } else {
        return []
      }
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },
}
</script>

<style lang="scss">
.min-w-60 {
  min-width: 90px !important;
}
</style>
